import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useComplianceCentre } from '../context/ComplianceCentreContext';
import { fileUrl, formatDate } from '../complianceCentreUi';

const titles = { actions: 'All Open Actions', activity: 'Recent Saved Activity', documents: 'Supporting Documents', events: 'Upcoming Events', expiring: 'Expiring Equipment Contracts & Warranties', calendar: 'Equipment Events Calendar' };
export default function ComplianceCentreDialog() {
  const { panel, setPanel, data, selectedDate, emptyMessage } = useComplianceCentre();
  const dialog = useRef(null);
  const [month, setMonth] = useState(() => new Date(selectedDate + 'T00:00:00'));
  useEffect(() => {
    if (panel) dialog.current?.showModal();
    else dialog.current?.close();
  }, [panel]);
  useEffect(() => {
    if (panel === 'calendar') {
      const date = new Date(selectedDate + 'T00:00:00');
      setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
    }
  }, [panel, selectedDate]);
  const items = data?.[panel] || [];
  const offset = (month.getDay() + 6) % 7;
  const days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const localDay = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return <dialog ref={dialog} onCancel={() => setPanel(null)} onClick={event => { if (event.target === dialog.current) setPanel(null); }}
    aria-label={titles[panel] || 'Compliance records'} className="w-full max-w-3xl rounded-2xl border border-gray-100 bg-white p-6 text-slate-900 shadow-xl backdrop:bg-slate-900/30">
    <div className="flex items-center justify-between gap-3 mb-5">
      <h2 className="text-lg font-extrabold">{titles[panel]}</h2>
      <button type="button" onClick={() => setPanel(null)} className="rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-bold">Close</button>
    </div>
    {panel === 'calendar' ? <>
      <div className="mb-4 flex items-center justify-between text-sm">
        <button type="button" aria-label="Previous month" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))} className="rounded-lg border border-gray-200 px-3 py-1">‹</button>
        <span className="font-bold">{month.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}</span>
        <button type="button" aria-label="Next month" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))} className="rounded-lg border border-gray-200 px-3 py-1">›</button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-xs">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(day => <div key={day} className="py-2 text-center font-bold text-slate-400">{day}</div>)}
        {Array.from({ length: offset }, (_, index) => <div key={'offset-' + index} />)}
        {Array.from({ length: days }, (_, index) => {
          const day = index + 1, date = localDay(new Date(month.getFullYear(), month.getMonth(), day));
          return <div key={date} className="min-h-20 rounded-lg border border-gray-100 p-2"><span>{day}</span>
            {(data?.events || []).filter(event => event.date === date).map(event => <Link key={event.id} to={event.path} className="mt-1 block truncate rounded bg-blue-50 px-1 py-1 text-[10px] font-bold text-blue-600" title={event.title}>{event.title}</Link>)}
          </div>;
        })}
      </div>
      <p className="mt-4 text-xs text-slate-400">Saved equipment schedules for the 30 days following the range end date. Inspection and audit schedules are not tracked.</p>
    </> : <div className="max-h-[65vh] overflow-auto divide-y divide-gray-100">
      {!items.length && <p className="py-5 text-sm text-slate-400">{emptyMessage('No records available.')}</p>}
      {items.map(item => panel === 'documents' ? <a key={item.id} href={fileUrl(item.url) || undefined} target="_blank" rel="noreferrer" className="block py-3 text-left hover:bg-slate-50">
        <span className="block text-sm font-bold text-blue-600">{item.name}</span><span className="text-xs text-slate-400">{item.category} · {formatDate(item.date)} · {item.owner}</span>
      </a> : <Link key={item.id} to={item.path} className="block py-3 text-left hover:bg-slate-50">
        <span className="block text-sm font-bold">{item.action || item.title}</span>
        <span className="block text-xs text-slate-400 mt-1">{panel === 'actions' ? `${item.area} · Priority: ${item.priority || 'Not tracked'} · Due: ${formatDate(item.dueDate)} · ${item.assignedTo}` : panel === 'activity' ? `${item.subtitle} · ${formatDate(item.date)} · ${item.author}` : formatDate(item.date)}</span>
      </Link>)}
    </div>}
  </dialog>;
}
